module.exports = __webpack_public_path__ + "media/S2E2_RetailVideo.7164bc33.mp4";